export default __webpack_public_path__ + "static/media/fast-loading-concept-illustration_114360-756.003f3e04.jpg";